export const useComponentLoad = function (val) {
  const ids = ref([])
  const count = computed(() => ids.value.length)

  const onComponentLoad = function (id, label) {
    ids.value.push(id)
    ids.value = [...new Set(ids.value)]
    // console.log("onComponentLoad", id, label)
  }

  const loaded = computed(() => count.value >= val)

  return {
    ids,
    count,
    loaded,
    onComponentLoad,
  }
}

export default useComponentLoad
